module.exports = __webpack_public_path__ + "img/calendar-2.5e2056b8.svg";